import * as React from 'react'
import classNames from 'classnames'
import { Text, TextName, Pill } from 'sdk'
import { useWindowSize } from 'core/hooks/useWindowSize'
import { ActionButtonDiscover } from 'sdk/action-buttons/ActionButtonDiscover'

import classes from './style.module.scss'

interface ComponentProps {
  imageDesktop: string
  imageMobile: string
  title: string
  children: React.ReactNode
  className?: string
  reverse?: boolean
  pillIcon?: string
  pillText?: string
  buttonLink?: string
  buttonText?: string
  aspectRatio?: string
}

export const ImageTextBlockNew: React.FC<ComponentProps> = (props) => {
  const { imageDesktop, imageMobile, title, children, className, reverse = false, pillIcon, pillText, buttonLink, buttonText, aspectRatio } = props

  const { width } = useWindowSize()
  const isTablet = width <= 1024

  const renderPill = () => {
    if (!pillIcon || !pillText) return null
    return <Pill text={pillText} icon={pillIcon} variant='gradient' />
  }

  return (
    <div className={classNames(classes.container, reverse && classes.reverse, className)}>
      <div
        className={classes.imageContainer}
        style={
          {
            '--image-desktop': `url(${imageDesktop})`,
            '--image-mobile': `url(${imageMobile})`,
            ...(aspectRatio && { '--aspect-ratio': aspectRatio }),
          } as React.CSSProperties
        }
      >
        {isTablet && (
          <div className={classes.pillMobile}>{renderPill()}</div>
        )}
      </div>
      <div className={classes.contentContainer}>
        {!isTablet && (
          <div className={classes.pillDesktop}>{renderPill()}</div>
        )}
        <Text type={TextName.H2} className={classes.title}>
          {title}
        </Text>
        <div className={classes.content}>{children}</div>
        {buttonLink && (
          <ActionButtonDiscover href={buttonLink} className={classes.button} />
        )}
      </div>
    </div>
  )
}
